'use strict';
angular.module('mean.accounts-receivable').factory('contractEstimateService', ['$q', '$filter',
    function($q, $filter) {
        

        var build = function(trade_code, company_code) {
            var ret_data = null;

            return ret_data;
        }

        

        return {
            build: build
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/services/contract-estimate-service.js